//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'GIFTCARDORDERWEBNOTRECEIVED',
  props: {
    locale: {
      type: Object,
      required: true
    }
  }
};